import * as THREE from 'three';
import Win from '../core/Win';
import Cursor from './Cursor';
import win from '../core/Win';
import Tween from "../core/Tween";
import Point from "./point";
import {GUI} from 'dat.gui';
// import {Pane} from 'tweakpane';
import Stats from 'three/examples/jsm/libs/stats.module.js'
import {EXRLoader} from 'three/examples/jsm/loaders/EXRLoader.js';
import {FBXLoader} from 'three/examples/jsm/loaders/FBXLoader.js';
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';
import { mergeVertices } from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js';
// @ts-ignore
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
// @ts-ignore
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
// @ts-ignore
import { GTAOPass } from 'three/examples/jsm/postprocessing/GTAOPass.js';
// @ts-ignore
import { OutputPass } from 'three/examples/jsm/postprocessing/OutputPass.js';
// @ts-ignore
import cameraData from '../../data/camera.json';
import Poyon from "./Poyon";
import Bar from "./bar";
import { ContactShadow } from "./ContactShadow";
export const devVert = require('../shader/devVert.glsl');
export const devFra = require('../shader/devFra.glsl');
const width = 10;
const scale = 15;
export default class Canvas {
    private _w: number;
    private _h: number;
    public renderer: THREE.WebGLRenderer;
    private container: HTMLElement;
    private _geometry: THREE.PlaneGeometry | null = null;
    private _material: THREE.ShaderMaterial;
    private _positionTex: THREE.Texture | null = null;
    private _mesh: THREE.Mesh;
    private camera: THREE.PerspectiveCamera;
    private cameraY: number;
    private fovRad: number;
    private dist: number;
    private time: number;
    private lastInnerHeight: number;
    private scene: THREE.Scene;
    private light: THREE.DirectionalLight;
    private _floor: THREE.Mesh;
    private _noImg: boolean;
    private _query: string;
    private cursor: Cursor;
    private angleCursor: Cursor;
    private _pos: any[] = [];
    private _pointProgress: any[] = [];
    private _degree: any[] = [];
    private vector = new THREE.Vector2();
    private _cPower: number = 0;
    private _cellLen: number = 10;
    private _size = Math.pow(width, 2);
    private _data = new Uint8Array(4 * this._size);
    private _stats = new Stats();
    private _movingTimer = 0;
    private _movingIndex = 0;
    private _detailNum = 1;
    private EXRLoader = new EXRLoader();
    private FBXLoader = new FBXLoader();
    private GLTFLoader = new GLTFLoader();
    private controls;
    private _composer: any;
    private _gtaoPass: any;
    private poyon: Poyon[] = [];
    private bar:Bar[]=[];
    private mStokers:THREE.Vector2[]=[];
    private _contactShadow: ContactShadow;

    private _devMouse:any;

    // スムーズカーソル
    private _cursorRaycaster = new THREE.Raycaster();
    private _raycastCamera: THREE.PerspectiveCamera; // レイキャスト専用（基準位置固定）
    private _floorPlane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0);
    private _cursorTargetWorld = new THREE.Vector3();   // レイキャストの生値
    private _cursorSmoothedWorld = new THREE.Vector3(); // lerp追従値
    private _cursorInitialized = false;
    private _debugCursorDiv: HTMLElement;
    private _smoothedScreenX = 0;
    private _smoothedScreenY = 0;
    private _isTouching = false;
    private _isTouchDevice = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
    private _cursorActive = 0.0;
    private _lastMouseMoveTime = 0;

    private _mouseX = 0;
    private _mouseY = 0;
    private _uiHidden = true;
    private _barHidden = false;

    // updateAngle 用：初期位置と、その姿勢から見た right ベクトル
    private _initialCameraPos: THREE.Vector3;
    private _initialCameraRight: THREE.Vector3;

    // タップとドラッグの判別用（touchstart直後はカメラ移動扱いしない）
    private _angleDragSuppressed = false;
    private _angleTouchStartX = 0;
    private _angleTouchStartY = 0;
    private _lastAngleMousePos = { x: 0, y: 0 };

    constructor() {
        this.container = document.getElementById('container') as HTMLElement;
        this._devMouse = document.querySelectorAll('.js_mStoker');

        this._stats.showPanel(0);
        document.body.appendChild(this._stats.dom);
        this._stats.dom.style.display = 'none';
        this.cursor = new Cursor();
        this.angleCursor = new Cursor();
        this._query = window.location.search.slice(1);
        this._noImg = this._query === 'noimg';
        this._w = this.container.clientWidth;
        if (Win.isPc) {
            this._h = window.innerHeight;
            this.lastInnerHeight = window.innerHeight;
        } else {
            this._h = window.screen.availHeight;
            this.lastInnerHeight = window.innerHeight;
        }
        this.renderer = new THREE.WebGLRenderer({antialias: true});
        this.renderer.setSize(this._w, this._h);
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setClearColor(0xF1ECE2, 1); // ライティング後の床の見た目に合わせた値
        this.renderer.shadowMap.enabled = true;
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        this.renderer.toneMapping = THREE.ACESFilmicToneMapping; // 白飛び抑制・自然な階調
        this.renderer.toneMappingExposure = 1.15;                // 暗いパレット引いても沈まない明るさ
        // transmission（物理ベース透過）を使うために必要
        (this.renderer as any).transmissionSampler = true;
        this.container.appendChild(this.renderer.domElement);
        const fov = 60;
        this.fovRad = (fov / 2) * (Math.PI / 180);
        this.dist = this._h / 2 / Math.tan(this.fovRad);
        if (Win.isPc) {
            this.cameraY = 0;
        } else {
            this.cameraY = this.lastInnerHeight - this._h;
        }
        const dist = cameraData.distance * scale;
        this.camera = new THREE.PerspectiveCamera(
            cameraData.fov,
            this._w / this._h,
            dist * 0.1,
            dist * 3,
        );
        // カメラ位置（スマホは上から見て反時計回りに10°回転させてデフォルト画角を調整）
        const defaultPos = new THREE.Vector3(
            cameraData.position[0] * scale,
            cameraData.position[1] * scale,
            cameraData.position[2] * scale,
        );
        this._adjustSpCameraPos(defaultPos);
        this.camera.position.copy(defaultPos);
        this.camera.lookAt(0, 0, 0);
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.camera.updateProjectionMatrix();

        // 注視点中心の回転制御用：初期位置と、その姿勢から見た right ベクトルを保存
        this._initialCameraPos = defaultPos.clone();
        const initialForward = new THREE.Vector3().subVectors(new THREE.Vector3(0, 0, 0), this._initialCameraPos).normalize();
        this._initialCameraRight = new THREE.Vector3().crossVectors(initialForward, new THREE.Vector3(0, 1, 0)).normalize();

        // レイキャスト専用カメラ（基準位置に固定、タッチによるカメラ移動の影響を受けない）
        this._raycastCamera = this.camera.clone();
        this._raycastCamera.updateMatrixWorld();

        this.time = 0;
        this.scene = new THREE.Scene();

        // スタジオ環境マップ → MeshPhysicalMaterial の広いハイライトに必要
        const pmrem = new THREE.PMREMGenerator(this.renderer);
        this.scene.environment = pmrem.fromScene(new RoomEnvironment()).texture;
        this.scene.environmentIntensity = 0.7; // オブジェクト暗面を床影と同程度の濃さに
        pmrem.dispose();

        const ambientLight = new THREE.AmbientLight(0xFFF8F0, 0.35); // やや抑えて床の影を濃く（直射は Directional で確保）
        this.scene.add(ambientLight);

        this.light = new THREE.DirectionalLight(0xFFF8F0, 1.8); // 温かみのある白・強さを落とす
        // this.light.position.set(700, 700, -300); // 右奥上方から → 影が左前に、逆光ぎみ
        this.light.position.set(40, 1200, -40); // 右奥上方から → 影が左前に、逆光ぎみ
        this.light.target.position.set(0, 0, 0);
        this.scene.add(this.light.target);
        this.light.castShadow = true;
        this.light.shadow.mapSize.width = 1024;
        this.light.shadow.mapSize.height = 1024;
        this.light.shadow.camera.near = 1;
        this.light.shadow.camera.far = 2000;
        this.light.shadow.camera.left = -1200;
        this.light.shadow.camera.right = 1200;
        this.light.shadow.camera.top = 1200;
        this.light.shadow.camera.bottom = -1200;
        this.light.shadow.bias = -0.001;
        this.light.shadow.radius = 100;
        this.light.shadow.camera.updateProjectionMatrix();
        this.scene.add(this.light);

        // 真上から照らす接地影専用ライト（光源としての明るさ0、影だけ出す）
        const contactLight = new THREE.DirectionalLight(0xffffff, 0);
        contactLight.position.set(0, 800, 0);
        contactLight.target.position.set(0, 0, 0);
        contactLight.castShadow = false;
        (contactLight.shadow as any).intensity = 0.5;
        contactLight.shadow.mapSize.width = 1024;
        contactLight.shadow.mapSize.height = 1024;
        contactLight.shadow.camera.near = 1;
        contactLight.shadow.camera.far = 900;
        contactLight.shadow.camera.left = -600;
        contactLight.shadow.camera.right = 600;
        contactLight.shadow.camera.top = 600;
        contactLight.shadow.camera.bottom = -600;
        contactLight.shadow.bias = -0.001;
        contactLight.shadow.radius = 30;
        contactLight.shadow.camera.updateProjectionMatrix();
        this.scene.add(contactLight);
        this.scene.add(contactLight.target);

        // 床（影受け用）
        const floorGeo = new THREE.PlaneGeometry(7200, 7200);
        const floorMat = new THREE.MeshStandardMaterial({
            color: 0xF0E8DC, // 背景と同じオフホワイト
            roughness: 1.0,
            metalness: 0.0,
        });
        this._floor = new THREE.Mesh(floorGeo, floorMat);
        this._floor.rotation.x = -Math.PI / 2;
        this._floor.position.y = 0;
        this._floor.receiveShadow = false;
        this.scene.add(this._floor);

        this._contactShadow = new ContactShadow(this.scene, 2200);
        this._contactShadow.setLightPosition(this.light.position);
        this._contactShadow.plane.visible = true;

        // ---- ポストプロセス（GTAO） ----
        this._composer = new EffectComposer(this.renderer);
        this._composer.addPass(new RenderPass(this.scene, this.camera));
        this._gtaoPass = new GTAOPass(this.scene, this.camera, this._w, this._h);
        this._gtaoPass.output = GTAOPass.OUTPUT.Default;
        this._gtaoPass.updateGtaoMaterial({
            radius: 0.5,
            distanceExponent: 2.,
            thickness: 10.,
            scale: 1.,
            samples: 16,
        });
        this._gtaoPass.updatePdMaterial({
            lumaPhi: 10.,
            depthPhi: 2.,
            normalPhi: 3.,
            radius: 4.,
            rings: 2,
            samples: 16,
        });
        this._gtaoPass.blendIntensity = 1.0; // temporal蓄積を無効化（毎フレーム完全上書き）
        this._composer.addPass(this._gtaoPass);
        this._composer.addPass(new OutputPass());

        // ---- ローディング（実ロード連動）----
        const loadingEl  = document.getElementById('loading') as HTMLElement;
        const loadingBar = document.getElementById('loading-bar') as HTMLElement;

        // ---- ポヨン生成（全員同時ロード）----
        const FRAME_COUNT  = 601;
        let   interval     = Math.round(FRAME_COUNT / 6);
        const poyonCount   = Math.floor(FRAME_COUNT / interval);
        const matOffset    = Math.floor(Math.random() * 2) + 1; // 1 or 2
        let   loadedCount  = 0;

        const reassignTimes = () => {
            const now = performance.now();
            this.poyon.forEach((p, i) => {
                p.time = -interval * i;
                p._firstLoop = true;
                p._lastTime = now; // デルタ計算をリセット（ロード時間分の跳びを防止）
            });
        };

        // マテリアルタイプごとに等間隔な hue オフセットを割り当て（同タイプ内での色被りを防ぐ）
        const matGroupSize: Record<number, number> = {};
        for (let i = 0; i < poyonCount; i++) {
            const mat = (i + matOffset) % 3;
            matGroupSize[mat] = (matGroupSize[mat] ?? 0) + 1;
        }
        const matGroupIdx: Record<number, number> = {};

        // 6個構成: vivid 3個 (ド派手) / mid 2個 (ほどほどカラフル) / soft 1個 (柔らかいパステル)
        // soft 枠は 1/3 確率で quiet (ほぼ白) に置換 → quiet は平均 18個に 1個出現
        // 前半 (i=0,1,2) に vivid を集中、後半 (i=3,4,5) に mid/soft/quiet を配置
        const moodAssign: ('quiet' | 'soft' | 'mid' | 'vivid')[] = new Array(poyonCount).fill('mid');
        const half = Math.ceil(poyonCount / 2);
        const shuffle = <T,>(arr: T[]) => {
            for (let k = arr.length - 1; k > 0; k--) {
                const j = Math.floor(Math.random() * (k + 1));
                [arr[k], arr[j]] = [arr[j], arr[k]];
            }
            return arr;
        };
        const frontIdx = shuffle(Array.from({ length: half }, (_, k) => k));
        const backIdx  = shuffle(Array.from({ length: poyonCount - half }, (_, k) => k + half));
        // 前半全員 vivid
        for (const i of frontIdx) moodAssign[i] = 'vivid';
        // 後半: 1個目を soft (or 1/3 の確率で quiet)、残り mid
        const useQuiet = Math.random() < (poyonCount / 18);
        moodAssign[backIdx[0]] = useQuiet ? 'quiet' : 'soft';
        for (let k = 1; k < backIdx.length; k++) moodAssign[backIdx[k]] = 'mid';

        const pendingPoyons: (Poyon | null)[] = new Array(poyonCount).fill(null);
        for (let i = 0; i < poyonCount; i++) {
            const matType = (i + matOffset) % 3;
            const gIdx = matGroupIdx[matType] = (matGroupIdx[matType] ?? 0) + 1;
            // 同 _index 内の2個に variant 0/1 を割り当て、見た目を明確に分ける
            const variant = (gIdx - 1) % 2;
            const mood = moodAssign[i];
            const p = new Poyon(this.scene, matType, this.camera, i % 3, variant, mood);
            // 全6個で hue を分散させる（ random offset で初期色相を毎回変える ）
            p._hueOffset = i / poyonCount + Math.random() * (1 / poyonCount);
            p.onReady = () => {
                pendingPoyons[i] = p; // 作成順を保持
                loadedCount++;
                loadingBar.style.transform = `scaleX(${loadedCount / poyonCount})`;
                if (loadedCount === poyonCount) {
                    // 全員揃ったら即アニメ開始（ローディングの裏で進行）
                    this.poyon.push(...pendingPoyons as Poyon[]);
                    reassignTimes();
                    // ポヨンが画面に入る頃にフェードアウト
                    setTimeout(() => { // ポヨン入場とフェードアウトを被せる
                        loadingEl.classList.add('is-hidden');
                        setTimeout(() => {
                            loadingEl.classList.add('is-hide-complete');
                        }, 500);
                    }, 1000);
                }
            };
        }

        for (let i = 0; i < 2; i++) {
            const bar = new Bar(this.scene,i);
            this.bar.push(bar);
        }

        // デバッグ用カーソル表示div
        this._debugCursorDiv = document.createElement('div');
        Object.assign(this._debugCursorDiv.style, {
            position: 'fixed',
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            background: 'rgba(255, 0, 80, 0.6)',
            border: '2px solid rgba(255, 255, 255, 0.8)',
            pointerEvents: 'none',
            zIndex: '9999',
            display: 'none',
            transform: 'translate(-50%, -50%)',
        });
        document.body.appendChild(this._debugCursorDiv);

        // カーソル状態トラッキング
        window.addEventListener('mousemove', () => { this._lastMouseMoveTime = performance.now(); });
        window.addEventListener('touchstart', (e: TouchEvent) => {
            this._isTouching = true;
            // タップ判定の保留：閾値超えるまで updateAngle は前回値を使う
            if (e.touches.length > 0) {
                this._angleDragSuppressed = true;
                this._angleTouchStartX = e.touches[0].clientX;
                this._angleTouchStartY = e.touches[0].clientY;
            }
        }, { passive: true });
        window.addEventListener('touchmove', (e: TouchEvent) => {
            if (!this._angleDragSuppressed || e.touches.length === 0) return;
            const t = e.touches[0];
            const dx = t.clientX - this._angleTouchStartX;
            const dy = t.clientY - this._angleTouchStartY;
            // 10px以上動いたらドラッグ扱いに切り替え
            if (dx * dx + dy * dy >= 100) this._angleDragSuppressed = false;
        }, { passive: true });
        window.addEventListener('touchend',   (e) => { if (e.touches.length === 0) this._isTouching = false; });
        window.addEventListener('touchcancel', (e) => { if (e.touches.length === 0) this._isTouching = false; });

        // UI非表示ショートカット（hキー）— Stats / loading をトグル
        window.addEventListener('keydown', (e) => {
            if (e.key === 'h' || e.key === 'H') {
                this._uiHidden = !this._uiHidden;
                const display = this._uiHidden ? 'none' : 'block';
                this._stats.dom.style.display = display;
                const loading = document.getElementById('loading');
                if (loading) loading.style.display = display;
            }
            // bキー: バー表示トグル
            if (e.key === 'b' || e.key === 'B') {
                this._barHidden = !this._barHidden;
                this.bar.forEach((b) => {
                    // @ts-ignore
                    b._childMeshes.forEach(({ mesh }) => {
                        mesh.visible = !this._barHidden;
                    });
                });
            }
        });

        this._w = this.container.clientWidth;
        this._h = Win.isPc ? window.innerHeight : window.screen.availHeight;

        const _fireRipple = (clientX: number, clientY: number) => {
            const ndcX =  (clientX / window.innerWidth)  * 2 - 1;
            const ndcY = -(clientY / window.innerHeight) * 2 + 1;
            const mouse = new THREE.Vector2(ndcX, ndcY);
            const raycaster = new THREE.Raycaster();
            raycaster.setFromCamera(mouse, this.camera);
            const plane = new THREE.Plane(new THREE.Vector3(0, 0, 1), 0);
            const target = new THREE.Vector3();
            raycaster.ray.intersectPlane(plane, target);
            this.poyon.forEach(p => p.addRipple(target));
        };

        this.container.addEventListener('click', (e: MouseEvent) => {
            _fireRipple(e.clientX, e.clientY);
        });

        this.container.addEventListener('touchstart', (e: TouchEvent) => {
            const t = e.touches[0];
            _fireRipple(t.clientX, t.clientY);
        }, { passive: true });
    }

    resized(): void {
        this._w = this.container.clientWidth;
        this._h = Win.isPc ? window.innerHeight : window.screen.availHeight;
        this.renderer.setSize(this._w, this._h);
        this._composer.setSize(this._w, this._h);
        this.camera.aspect = this._w / this._h;
        this.camera.updateProjectionMatrix();
        this.poyon.forEach((poyon,i)=>{
            poyon.resized();
        })
    }

    updateAngle(){
        // タップ判定中は前回値を使い回し、ドラッグ確定後に lerp を再開
        let mousePos: { x: number, y: number };
        if (this._angleDragSuppressed) {
            mousePos = this._lastAngleMousePos;
        } else {
            mousePos = this.angleCursor.getCurrentMousePosition();
            this._lastAngleMousePos = { x: mousePos.x, y: mousePos.y };
        }
        // 注視点（原点）まわりの回転量。x: 世界Y軸 / y: カメラ初期姿勢のright軸
        const angleX = Win.isPc ? 0.4 : 0.9;
        const angleY = Win.isPc ? -0.3 : -0.5;
        const basePos = this._initialCameraPos.clone();
        basePos.applyAxisAngle(new THREE.Vector3(0, 1, 0), mousePos.x * angleX);
        basePos.applyAxisAngle(this._initialCameraRight, mousePos.y * angleY);
        this.camera.position.copy(basePos);
        this.camera.lookAt(0, 0, 0);
    }
    // スマホ時のデフォルト画角調整（距離1.25倍 / Y軸まわり25°回転 / Y方向-2500シフト）
    private _adjustSpCameraPos(pos: THREE.Vector3) {
        if (Win.isPc) return;
        pos.multiplyScalar(1.5);
        pos.applyAxisAngle(new THREE.Vector3(0, 1, 0), 35 * Math.PI / 180);
        pos.y += -2500;
    }
    updateCursor(){
        // レンダラーと同じサイズでNDCを計算（タッチデバイスのズレ防止）
        const rawPos = this.cursor.getPosition();
        const ndcX =  (rawPos.x / this._w)  * 2 - 1;
        const ndcY = -(rawPos.y / this._h) * 2 + 1;

        // 基準位置固定のカメラでレイキャスト（タッチによるカメラ移動の影響を受けない）
        this._cursorRaycaster.setFromCamera(
            new THREE.Vector2(ndcX, ndcY),
            this._raycastCamera,
        );
        this._cursorRaycaster.ray.intersectPlane(this._floorPlane, this._cursorTargetWorld);

        // 初回は即座にセット
        if (!this._cursorInitialized) {
            this._cursorSmoothedWorld.copy(this._cursorTargetWorld);
            this._cursorInitialized = true;
        }

        // lerp追従
        const lerpSpeed = 0.15;
        this._cursorSmoothedWorld.x += (this._cursorTargetWorld.x - this._cursorSmoothedWorld.x) * lerpSpeed;
        this._cursorSmoothedWorld.y += (this._cursorTargetWorld.y - this._cursorSmoothedWorld.y) * lerpSpeed;
        this._cursorSmoothedWorld.z += (this._cursorTargetWorld.z - this._cursorSmoothedWorld.z) * lerpSpeed;

        // カーソルアクティブ状態のスムージング
        // タッチ: 指が触れている間ON / PC: mousemoveから100ms以内ならON
        const isActive = this._isTouchDevice
            ? this._isTouching
            : (performance.now() - this._lastMouseMoveTime < 100);
        const target = isActive ? 1.0 : 0.0;
        const activeSpeed = isActive ? 0.12 : 0.05;
        this._cursorActive += (target - this._cursorActive) * activeSpeed;

        // ポヨンにワールド座標とアクティブ度を渡す（ロード済みのみ）
        this.poyon.forEach((poyon) => {
            poyon.setCursorWorld(this._cursorSmoothedWorld, this._cursorActive);
        });

        // デバッグdiv: スクリーン座標で直接lerp（再投影せず確実）
        this._smoothedScreenX += (rawPos.x - this._smoothedScreenX) * lerpSpeed;
        this._smoothedScreenY += (rawPos.y - this._smoothedScreenY) * lerpSpeed;
        this._debugCursorDiv.style.left = `${this._smoothedScreenX}px`;
        this._debugCursorDiv.style.top = `${this._smoothedScreenY}px`;
    }

    updated(): void {
        // updated はロード済みユニークのみ（同じインスタンスを二重に進めない）
        this.poyon.forEach((poyon) => {
            poyon.updated();
        })

        this.updateCursor();  // カメラ移動前にレイキャスト（タッチデバイスでの干渉防止）
        this.updateAngle();

        this._stats.begin();
        this._stats.end();
        this.cursor.startTimer();
        this._movingTimer = this.cursor.getMovingTime();
        this._movingIndex = Math.floor(this._movingTimer / (250)) % (this._cellLen + 1);
        this.time += .5;

        this._contactShadow.update(this.renderer, this.scene, [this._floor]);
        // デバッグ: EffectComposer（GTAO）をバイパスして直接レンダリング
        this.renderer.render(this.scene, this.camera);
        // this._composer.render();


        this.vector = this.cursor.getVector();
        this._cPower = Math.abs(Math.sqrt(this.vector.x * this.vector.x + this.vector.y * this.vector.y) - 1) * 100;
    }
}
